import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';
import { STATISTICS_THEME as T } from './statisticsOverlayConstants';

export default function MetricCard({ label, value, accent, calculation, loading = false, fullWidth = false }) {
  return (
    <Tooltip
      title={calculation || ''}
      describeChild
      arrow
      enterDelay={250}
      componentsProps={{
        popper: { sx: { zIndex: 'calc(var(--z-index-modal-content) + 4)' } },
        tooltip: { sx: { maxWidth: 560, maxHeight: '60vh', overflowY: 'auto', whiteSpace: 'pre-line', overflowWrap: 'anywhere', fontSize: 12, lineHeight: 1.6 } }
      }}>
      <Box
        tabIndex={calculation ? 0 : undefined}
        aria-busy={loading}
        sx={{
          gridColumn: fullWidth ? '1 / -1' : 'auto',
          background: T.surfaceAlt,
          border: '1px solid rgba(255, 255, 255, 0.5)',
          borderRadius: 1.5,
          boxShadow: '0 3px 18px rgba(15, 23, 42, 0.08)',
          backdropFilter: 'blur(3px)',
          WebkitBackdropFilter: 'blur(3px)',
          px: 1.25,
          py: 1.15
        }}>
        <Typography sx={{ color: T.textHint, fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.8 }}>{label}</Typography>
        <Typography sx={{ color: accent || T.textPrimary, fontSize: 20, fontWeight: 800, mt: 0.35 }}>
          {loading ? <CircularProgress size={20} thickness={4.5} sx={{ color: accent || T.textPrimary, verticalAlign: 'middle' }} aria-label={`Loading ${label}`} /> : value}
        </Typography>
      </Box>
    </Tooltip>
  );
}
